import { formatContactPreferences } from '@application/utils';
import {
  LoadingContainer,
  MtFormButtons,
  MtFormContainer,
  Section,
  ContactPreferences,
} from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import { Form, useFormikContext } from 'formik';
import type { FC } from 'react';
import type { UnsubscribePageFormValues, UnsubscribePageProps } from './types';

export * from './types';

export const UnsubscribePage: FC<UnsubscribePageProps> = (props) => {
  const { loading = false, onChangeContactPreferenceClick, isRegisteredUser } = props;
  const { translate } = useTranslation();

  const { resetForm, isSubmitting } = useFormikContext<UnsubscribePageFormValues>();
  const emails = formatContactPreferences(translate, isRegisteredUser);

  if (loading) return <LoadingContainer />;

  return (
    <MtFormContainer>
      <Form>
        <Section>
          <ContactPreferences
            mode="edit"
            onChangeContactPreferenceClick={onChangeContactPreferenceClick}
            emails={emails}
          />
        </Section>

        <Section>
          <MtFormButtons
            showSubmit
            showCancel
            onCancelClick={() => {
              resetForm();
            }}
            submitLoading={isSubmitting}
          />
        </Section>
      </Form>
    </MtFormContainer>
  );
};
